:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

.wrapper {
  flex-direction: column;
  margin-top: 10px;

  .actions-wrapper {
    margin-top: 2%;
    height: 5%;
    padding-left: 2%;
  }

  #integrity-monitor-pause-targets {
    #integrity-monitor-pause-targets-value {
      font-size: var(--body-size-medium);
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90%;
      font-weight: 400;
      line-height: 16px;
    }
  }

  .bottom-buttons {
    width: 100%;
    flex-basis: 65px;
    min-height: 65px;
    margin-top: auto;
    display: flex;
    align-items: center;

    border-top: 1px solid var(--surface-1);

    padding-left: calc(var(--spacer) * 4);
    padding-right: calc(var(--spacer) * 4);
    box-shadow: 0px 0px 4px rgb(0 0 0 / 16%);

    gz-button {
      margin-right: calc(var(--spacer) * 2);

      &#cancel-button {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }
}
